import React from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToLounge = () => {
    document.getElementById('lounge-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToBeach = () => {
    document.getElementById('beach-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="parallax-hero">
      <div className="grid grid-cols-1 md:grid-cols-2 h-full">
        {/* Left Side - Saale Lounge */}
        <div
          className="relative h-full cursor-pointer group overflow-hidden"
          onClick={scrollToLounge}>

          <div
            className="absolute inset-0 transition-transform duration-700 group-hover:scale-110"
            style={{
              backgroundImage: 'url(https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/5h6ns2wd_IMG-20260315-WA0021.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }} />

          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/50" />
          <div className="hero-overlay opacity-60" />
          
          <div className="relative h-full flex flex-col items-center justify-center text-center px-4 z-10">
            <h1
              className="neon-text font-display text-5xl md:text-7xl lg:text-8xl font-bold mb-4 transition-all duration-300 group-hover:scale-110"
              style={{
                fontFamily: "'Great Vibes', cursive",
                letterSpacing: '0.05em',
                WebkitTextStroke: '2px white',
                paintOrder: 'stroke fill'
              }}>

              Saale Lounge
            </h1>
            
            <div className="mt-6">
              <a 
                href="#lounge-section" 
                className="neon-button inline-block"
                onClick={(e) => { e.stopPropagation(); }}
                style={{
                  background: '#FF00FF',
                  color: 'white',
                  borderColor: '#FF00FF',
                  fontWeight: 700,
                  opacity: 0.9,
                  boxShadow: '0 0 20px #FF00FF, 0 0 40px #FF00FF, inset 0 0 10px rgba(255, 255, 255, 0.2)',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  animation: 'neon-pulse-pink 2s ease-in-out infinite'
                }}
              >
                Zur Saale Lounge
              </a>
            </div>
          </div>
        </div>

        {/* Right Side - Saale Beach */}
        <div
          className="relative h-full cursor-pointer group overflow-hidden"
          onClick={scrollToBeach}>

          <div
            className="absolute inset-0 transition-transform duration-700 group-hover:scale-110"
            style={{
              backgroundImage: 'url(https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/1nmibt8u_Darker%20-%202026-03-29T171405.962.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }} />

          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/50" />
          <div className="absolute inset-0 bg-black/30" />
          
          <div className="relative h-full flex flex-col items-center justify-center text-center px-4 z-10">
            <h1
              className="font-display text-5xl md:text-7xl lg:text-8xl font-bold mb-4 transition-all duration-300 group-hover:scale-110"
              style={{
                fontFamily: "'Great Vibes', cursive",
                letterSpacing: '0.05em',
                color: '#FFD700',
                textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.5)',
                WebkitTextStroke: '2px black',
                paintOrder: 'stroke fill'
              }}>

              Saale Beach
            </h1>
            
            <div className="mt-6">
              <a 
                href="#beach-section" 
                className="neon-button inline-block"
                onClick={(e) => { e.stopPropagation(); }}
                style={{
                  background: '#FFD700',
                  color: 'white',
                  borderColor: '#FFD700',
                  fontWeight: 700,
                  boxShadow: '0 0 20px #FFD700, 0 0 40px #FFD700, inset 0 0 10px rgba(255, 255, 255, 0.2)',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  animation: 'neon-pulse 2s ease-in-out infinite'
                }}
              >
                Zum Saale Beach
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <ChevronDown className="text-white w-8 h-8" style={{ filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.5))' }} />
      </div>

      {/* Vertical Divider */}
      <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gradient-to-b from-transparent via-white/30 to-transparent z-20 hidden md:block" />
    </div>);

};

export default HeroSection;